export default {
    useFixtures: false,
    ezLogin: false,
    yellowBox: false,
    reduxLogging: false,
    includeExamples: false,
    dev: true,
    useReactotron: false
}



// WEBPACK FOOTER //
// ./src/Config/DebugConfig.js